var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-header",class:_vm.classes},[_c('BQdtCard',{attrs:{"name":_vm.qdtHeaderName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }